import React from "react";
import PropTypes from "prop-types";

import BottomBar from "../../../ui/BottomBar";
import StepContainer from "../../../ui/StepContainer";
import StepForm from "../../../ui/StepForm";
import {
  STEP_STORAGE_KEYS,
  TRAFFIC_VOLUME_KEYS,
} from "../../../constants/storageConstants";
import { projectDataPropType } from "../../../util/propTypeHelper";
import VolumeAdjustmentFactorFields from "./VolumeAdjustmentFactorFields";
import Header from "../../../ui/Header";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routesConstants";

export default function VolumeAdjustmentFactors({ projectData, saveFormData }) {
  const navigate = useNavigate();
  const handleButtonClick = () => navigate(ROUTES.TRAFFIC_VOLUMES);
  return (
    <StepContainer withProgressStepper={false}>
      <StepForm
        onFormSubmit={handleButtonClick}
        projectData={projectData}
        saveFormData={saveFormData}
        storageKey={`${STEP_STORAGE_KEYS.TRAFFIC_VOLUMES}.${TRAFFIC_VOLUME_KEYS.VOLUME_ADJUSTMENT_FACTORS}`}
      >
        {({ defaultValues, errors, register }) => {
          return (
            <>
              <Header title="Volume Adjustment Factors" />
              <VolumeAdjustmentFactorFields
                defaultValues={defaultValues}
                errors={errors}
                register={register}
              />
              <BottomBar
                handleSecondaryButtonClick={handleButtonClick}
                isFullScreenWidth
                mainButtons={[{ label: "Save" }]}
                projectData={projectData}
                secondaryButtonLabel="Cancel"
                withSubmitButton
              />
            </>
          );
        }}
      </StepForm>
    </StepContainer>
  );
}

VolumeAdjustmentFactors.propTypes = {
  projectData: projectDataPropType.isRequired,
  saveFormData: PropTypes.func.isRequired,
};
